import React, {Component} from 'react'
import Text from "@amzn/meridian/text";
import {rtsRowMappingLegacy} from '../../commons/dataStore/PackageResultsData'
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import CommonFilters from "../../commons/CommonFilters"
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import Link from "@amzn/meridian/link";
import {FiltersStateContext} from '../../commons/context/FiltersStateContext';
import {handlePackageStateToGenericTextMapping} from "../../commons/CommonUtils";
import Loader from "@amzn/meridian/loader";
import {FormattedMessage} from "react-intl";
import Icon from "@amzn/meridian/icon";
import Tooltip from "@amzn/meridian/tooltip";
import chevronDownSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-down-small";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import infoKnockoutTokens from "@amzn/meridian-tokens/base/icon/info-knockout";
import {getRtsBucketDefinition} from "../../commons/dataStore/RTSBucketDefinitions";
import {PackageTypes_Reverse} from "../../commons/dataStore/FilterDataStore";
import RefreshTimer from "../../commons/RefreshTimer";
import {PAGE_HEADERS, RTS_PAGE_HEADER_METRIC, WASTE_TRANSFER_NOTE, FEATURES, COMPLIANCE_METRICS} from "../../commons/constants/CommonConstants";
import PageHeader from "../../commons/PageHeader";
import {isINRegion} from "../../util/CommonUtils";
import {chainWalk} from "../../commons/CommonUtils";
import {FeatureConfigContext} from "../../commons/context/FeatureConfigContext";
import Box from "@amzn/meridian/box";
import { processConditionalMetrics } from '../../util/MetricUtils';
import WTNInlineView from "../wtn/WTNInlineView";
import { sectionTestId, subsectionTestId, rowTestId, rtsRowSlug, rtsMessageId } from "../../commons/utils/testSelectors";

const WIDGET_COMPLIANCE_GREEN = "#007600";
const WIDGET_COMPLIANCE_RED = "#B12704";

const RTS_WIDGET_DEFINITIONS = {
    RTS_INDUCT_COMPLIANCE: {
        widgetId: "RTS_INDUCT_COMPLIANCE",
        titleId: "rts.induct_compliance",
        defaultTitle: "RTS Induct Compliance",
        tooltipId: "rts.induct_compliance_tooltip",
        defaultTooltip: "Percent of driver returned volume that is Reverse Inducted. (Reverse Inducted Reattemptable + Stowable + Stowed) ÷ (numerator + Self-Serve Return + Associate Debrief).",
        targetLabelId: "rts.induct_compliance_target",
        defaultTargetLabel: "Target: 95%",
        type: "percentage",
        fallbackTarget: 95
    },
    RTS_STOW_COMPLIANCE: {
        widgetId: "RTS_STOW_COMPLIANCE",
        titleId: "rts.stow_compliance",
        defaultTitle: "RTS Stow Compliance",
        tooltipId: "rts.stow_compliance_tooltip",
        defaultTooltip: "Percent of Reverse Inducted - Stowable packages that have been stowed. Stowed SC/FC-bound ÷ Total Reverse Inducted - Stowable. Note: This will update as more packages are INDUCTED.",
        targetLabelId: "rts.stow_compliance_target",
        defaultTargetLabel: "Target: 98%",
        type: "percentage",
        fallbackTarget: 98
    },
    PENDING_REVERSE_STOW: {
        widgetId: "PENDING_REVERSE_STOW",
        titleId: "rts.pending_reverse_stow",
        defaultTitle: "Pending Reverse Stow",
        tooltipId: "rts.pending_reverse_stow_tooltip",
        defaultTooltip: "Reverse Inducted and ready to be stowed into a reverse container.",
        unitId: "rts.pending_reverse_stow_unit",
        defaultUnit: "Packages",
        type: "count"
    },
    PENDING_REVERSE_INDUCT: {
        widgetId: "PENDING_REVERSE_INDUCT",
        titleId: "rts.pending_reverse_induct",
        defaultTitle: "Pending Reverse Induct",
        tooltipId: "rts.pending_reverse_induct_tooltip",
        defaultTooltip: "Custody transferred, pending reverse induct. This is the induct backlog.",
        unitId: "rts.pending_reverse_induct_unit",
        defaultUnit: "Packages",
        type: "count"
    }
};

const WIDGET_DRILLDOWN_STATUSES = {
    RTS_INDUCT_COMPLIANCE: COMPLIANCE_METRICS.INDUCT.drillDownStatuses,
    RTS_STOW_COMPLIANCE: COMPLIANCE_METRICS.STOW.drillDownStatuses,
    PENDING_REVERSE_STOW: ["Reverse Inducted — Stowable"],
    PENDING_REVERSE_INDUCT: ["Received (DS -> FC)", "RTS Received (DS -> Customer)", "Marked for Reprocess (DS -> FC)"]
};

// Only these keys may be overridden by the remote WidgetConfigStoreService config.
// The locale ids (titleId/tooltipId/...), the render `type` and `fallbackTarget` are
// owned by RTS_WIDGET_DEFINITIONS above and must NEVER be clobbered by the API
// payload: a config carrying e.g. {"type":"PERCENTAGE"} would push a compliance card
// down the count branch, whose `unitId` is undefined for that widget — react-intl then
// throws "[React Intl] An `id` must be provided to format a message." and blanks the page.
const REMOTE_CONFIG_OVERRIDES = ["displayName", "tooltip", "targetLabel"];

/**
 * Merges a widget's local definition with the (untrusted) remote config, letting the
 * remote config supply only display strings. Returns null for unknown widget ids.
 */
export function mergeWidgetConfig(widgetConfig, definitions = RTS_WIDGET_DEFINITIONS) {
    const definition = widgetConfig && definitions[widgetConfig.widgetId];
    if (!definition) return null;
    return REMOTE_CONFIG_OVERRIDES.reduce((merged, key) => {
        if (widgetConfig[key]) {
            merged[key] = widgetConfig[key];
        }
        return merged;
    }, {...definition});
}

function chunkWidgets(widgetConfigs, size) {
    const chunks = [];
    for (let index = 0; index < widgetConfigs.length; index += size) {
        chunks.push(widgetConfigs.slice(index, index + size));
    }
    return chunks;
}

export default class RTSDataUI extends Component {

 static contextType = FiltersStateContext;
 constructor(props) {
    super(props)
    this.state = {
          expandedSections : [],
          view : "RTS_VIEW"
    }

    this.toggleRow = section => {

        if (this.state.expandedSections.indexOf(section) !== -1) {
            this.setState({
             expandedSections : this.state.expandedSections.filter(expandedSection => expandedSection !== section)}
            )
        } 
        else  {
           this.setState({
             expandedSections : this.state.expandedSections.concat(section)

            })
        } 
    }

    this.getMetricFromPackageToColumnMap = (section, column, direction) => {

        var sectionData = this.props.data.filter(status => status.packageStatus === section);
        var timeToMetricDataMapForSection = sectionData && sectionData.length > 0 ? sectionData : [];
        var columnToMetricEntity = direction ?  (timeToMetricDataMapForSection.find(section => section.metaDataMap ? section.metaDataMap.direction === direction : null) ? 
        timeToMetricDataMapForSection.find(section => section.metaDataMap ? section.metaDataMap.direction === direction : null).columnToViewDataMap : []) :
            (timeToMetricDataMapForSection.length > 0 ? timeToMetricDataMapForSection[0].columnToViewDataMap : []) 
        if (column === "_MIN") {  
            column = JSON.stringify(columnToMetricEntity).match(/[0-9]*_MIN/g);
        }
        return columnToMetricEntity[column] ? columnToMetricEntity[column].value : 0
    }
    
        /**
        * This calculates total count for section metric
        */
    this.getSectionMetricFromSubsectionData = (section, column) => {

        var totalCount = 0;
        section.Subsections.length > 0 ? 
        section.Subsections.map(subsection =>  subsection.Section ?
                subsection.Subsections.map(s => totalCount+= Number(this.getMetricFromPackageToColumnMap((s.localeCompare(subsection.Section) !== 0 ? s.split(" (", 1)[0]: ""), column,  s.split(" (", 2)[1] ? s.split(" (", 2)[1].split(")" , 1)[0] : ""))) :
        (totalCount += Number(this.getMetricFromPackageToColumnMap(subsection.localeCompare(section.Section) !== 0 ? subsection.split(" (", 1)[0]: "", column,  subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")))) :
        //In case when there is no subsection
        totalCount += Number(this.getMetricFromPackageToColumnMap(section.Section, column))
        return totalCount

    }

   this.backendStateToMetricMapping = (subsection) => {

    return subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : subsection;
  }

    // Localized tooltip content for a waterfall bucket. The current product UX is
    // description-only, so each tooltip resolves to a single locale string.
    this.renderBucketTooltip = (label) => {
        const def = getRtsBucketDefinition(label);
        if (!def) return null;
        const slug = rtsRowSlug(label);
        return (
            <span>
                <div><FormattedMessage id={`commons.tooltip.${slug}.description`} defaultMessage={def.description}/></div>
            </span>
        );
    }

    // info tooltip for a waterfall bucket. Renders a hoverable info icon whose
    // tooltip lists the localized description for that bucket. Returns null when
    // the label has no defined definition (no empty tooltips). Flag-gated by this.props.renderTooltips—
    // default OFF, enabled per-station via FEATURES.IS_RTS_WATERFALL_CLEANUP_ENABLED.
    this.renderBucketInfo = (label) => {
        if (!this.props.renderTooltips) return null;
        const tooltipContent = this.renderBucketTooltip(label);
        if (!tooltipContent) return null;
        return (
            <Tooltip position="top" title={tooltipContent}>
                <span data-test={`info-${rtsRowSlug(label)}`}
                      style={{display: "inline-flex", alignItems: "center", marginInlineStart: 8, cursor: "help"}} tabIndex={0}>
                    <Icon tokens={infoKnockoutTokens}>Definition</Icon>
                </span>
            </Tooltip>
        );
    }

    this.getTimeColumn = () => {
        var match = JSON.stringify(this.props.data || []).match(/[0-9]*_MIN/g);
        return match && match[0] ? match[0] : "TOTAL";
    }

    this.getWidgetMetricValue = (metricName, valueName) => {
        const metricResult = this.props.widgetMetrics && this.props.widgetMetrics[metricName];
        if (!metricResult || !Array.isArray(metricResult.metricValues)) return null;
        const metricValue = metricResult.metricValues.find(value => value.name === valueName);
        // Normalize a missing/blank value to null so BOTH card types fall back to the
        // em-dash placeholder consistently (previously an `undefined` value leaked
        // through and rendered "undefined%" / NaN). A real 0 — e.g. zero packages
        // pending stow — is data, not a gap, and still renders as 0.
        return metricValue && metricValue.value !== null && metricValue.value !== undefined
            ? metricValue.value
            : null;
    }

    /**
     * Reads compliance percentage from widget API response.
     * Returns "X%" or "—" if unavailable.
     */
    this.getWidgetPercentage = (metricName) => {
        const percentageValue = this.getWidgetMetricValue(metricName, "COMPLIANCE_PERCENTAGE");
        return percentageValue !== null ? percentageValue + "%" : "—";
    }

    /**
     * Reads pending count from widget API response.
     * Returns the count, including zero, or "—" when PENDING is unavailable.
     */
    this.getWidgetCount = (metricName) => {
        const pendingValue = this.getWidgetMetricValue(metricName, "PENDING");
        if (pendingValue === null) return "—";
        return Math.round(pendingValue);
    }

    this.getWidgetTarget = (metricName, fallbackTarget) => {
        const targetValue = this.getWidgetMetricValue(metricName, "TARGET");
        return targetValue !== null ? targetValue : fallbackTarget;
    }

    /**
     * Compliance cards are green when they meet the configured target and red
     * when they miss it.
     */
    this.getWidgetColor = (metricName, fallbackTarget) => {
        const percentageValue = this.getWidgetMetricValue(metricName, "COMPLIANCE_PERCENTAGE");
        if (percentageValue === null) return null;
        const target = this.getWidgetTarget(metricName, fallbackTarget);
        return percentageValue >= target ? WIDGET_COMPLIANCE_GREEN : WIDGET_COMPLIANCE_RED;
    }

    this.getWidgetCardStyle = (widget) => {
        if (widget.type !== "percentage") return undefined;
        const color = this.getWidgetColor(widget.widgetId, widget.fallbackTarget);
        return color ? { borderTop: `4px solid ${color}` } : undefined;
    }

    this.getWidgetValueNode = (widget) => {
        const isPercentage = widget.type === "percentage";
        const widgetColor = isPercentage ? this.getWidgetColor(widget.widgetId, widget.fallbackTarget) : null;
        const displayValue = isPercentage ? this.getWidgetPercentage(widget.widgetId) : this.getWidgetCount(widget.widgetId);
        const valueNode = (
            <span style={widgetColor ? {color: widgetColor} : undefined}>
                {displayValue}
            </span>
        );
        const drillDownStatuses = WIDGET_DRILLDOWN_STATUSES[widget.widgetId];
        const timeColumn = this.getTimeColumn();
        return drillDownStatuses && displayValue !== "—"
            ? <Link href={this.constructState(drillDownStatuses, timeColumn)} type="secondary">{valueNode}</Link>
            : valueNode;
    }

    this.isSectionExpanded = section => {
        return (this.state.expandedSections.indexOf(section) !== -1);
    }

    this.constructState = (section, timeColumn) => {

        let subsections = Array.isArray(section)  ? [].concat.apply([], section): section;
        var values = {
            cycles : this.context.selectedFilterValues.cycles,
            startPDD : this.context.selectedFilterValues.startPDD,
            endPDD : this.context.selectedFilterValues.endPDD,
            packageTypes  : this.context.selectedFilterValues.packageTypes_Reverse ? [].concat.apply([], 
                this.context.selectedFilterValues.packageTypes_Reverse.map(packageType => {return PackageTypes_Reverse[packageType]})) : [], 
            dwellStartTime : timeColumn,
            dwellEndTime : "0_MIN",
            packageStatuses : Array.isArray(subsections) ? subsections : [subsections],
            leg : "Reverse",
            page : "DWELL"
        } 

        //Redirect to search path
        var path = window.location.href;
        var searchPath = path[path.length - 1] === "/" ? path + "packageSearch/" : path + "/packageSearch/";
        return searchPath + JSON.stringify(values).replace('/','%2f');
    }

    this.getAggregateRTSMetricRowData = () => {
        const filteredAggregatedRTSMetrics = this.props.data.filter(status => Object.keys(RTS_PAGE_HEADER_METRIC).includes(status.packageStatus));
        return filteredAggregatedRTSMetrics.map(metric => ({
            metricName: metric.packageStatus,
            metricValue: metric.columnToViewDataMap.TOTAL.value == null ? 0 : metric.columnToViewDataMap.TOTAL.value,
            metricVisibleName: RTS_PAGE_HEADER_METRIC[metric.packageStatus].metricVisibleName,
            metricVisibleUnit: metric.columnToViewDataMap.TOTAL.value === "1" ? RTS_PAGE_HEADER_METRIC[metric.packageStatus].metricVisibleUnit.slice(0, -1) : RTS_PAGE_HEADER_METRIC[metric.packageStatus].metricVisibleUnit
        }));
    }

}
 
render() {
    const selectedTypes = this.context.selectedFilterValues.packageTypes_Reverse || [];
    return (
    <FeatureConfigContext.Consumer>
    {({configViewModel}) => {
    const isEWasteWtnEnabled = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_EWASTE_WTN_ENABLED], false);
    const isWTNSelected = isEWasteWtnEnabled && selectedTypes.length === 1 && selectedTypes[0] === WASTE_TRANSFER_NOTE;
    // Skip expensive computations when rendering the WTN view
    // rowMapping is always supplied by the sole caller (RTSData, already flag-gated).
    // Fall back to the LEGACY mapping if it's ever absent — the safe rollback default
    // (never render flag-gated rows without an explicit flag) and it avoids spreading
    // undefined into processConditionalMetrics.
    const processedRtsRowMapping = !isWTNSelected ? processConditionalMetrics(this.props.data, [...(this.props.rowMapping || rtsRowMappingLegacy)]) : [];
    const timeColumn = !isWTNSelected ? this.getTimeColumn() : "TOTAL";
    const Columns = !isWTNSelected && this.props.data.length > 0 ? [timeColumn] : [];
    const aggregateRTSMetricRowData = !isWTNSelected ? this.getAggregateRTSMetricRowData() : [];
    const widgetConfigs = (this.props.widgetConfigs && this.props.widgetConfigs.length > 0 ? this.props.widgetConfigs : Object.keys(RTS_WIDGET_DEFINITIONS).map(widgetId => ({widgetId})))
        .map(widgetConfig => mergeWidgetConfig(widgetConfig))
        .filter(Boolean);
    const widgetRows = chunkWidgets(widgetConfigs, 2);
    // Gates the compliance/pending cards below, which read their values straight from
    // the widget API via getWidgetPercentage/getWidgetCount. Same WTN guard as above.
    const hasWidgetMetrics = Object.keys(this.props.widgetMetrics || {}).length > 0;
    const showComplianceCards = this.props.widgetCardsEnabled && !isWTNSelected && this.props.isSimplifiedView
        && widgetConfigs.length > 0 && (!this.props.widgetMetricsLoading || hasWidgetMetrics);
    return (
    <Column spacing="medium" spacingInset={this.props.spacingInset_shorthand2}>
        <PageHeader {...PAGE_HEADERS.RTS}/>
        <CommonFilters view={this.state.view} />
        {isWTNSelected ? (
            <WTNInlineView />
        ) : (
            <React.Fragment>
            {
            (isINRegion() && !this.props.isLoading && aggregateRTSMetricRowData.length > 0) ?
            <Row spacing="medium" spacingInset={this.props.spacingInset_shorthand4} width="100%">
                {
                    aggregateRTSMetricRowData.map(aggregateMetricRow => (
                        <Box key={aggregateMetricRow.metricName} type="outline" spacingInset="medium">
                            <Text type="h100">
                                <b><FormattedMessage id={rtsMessageId(aggregateMetricRow.metricVisibleName)} defaultMessage={aggregateMetricRow.metricVisibleName}/></b>
                            </Text>
                            <Text type="d50">
                              <Link href = { this.constructState(aggregateMetricRow.metricName, timeColumn)}
                                    type="secondary"> {aggregateMetricRow.metricValue} </Link>
                            </Text>
                            <Text type="b300" color={"secondary"}>
                                <FormattedMessage id={rtsMessageId(aggregateMetricRow.metricVisibleUnit)} defaultMessage={aggregateMetricRow.metricVisibleUnit} />
                            </Text>
                        </Box>
                    ))
                }
            </Row> : null
        }

        {showComplianceCards ? widgetRows.map((widgetRow, rowIndex) => (
        <Row key={`widget-row-${rowIndex}`} spacing="medium" widths={["grid-6", "grid-6"]} width="100%">
            {widgetRow.map(widget => {
                const isPercentage = widget.type === "percentage";
                // Meridian components don't forward an arbitrary `style` prop to the DOM
                // node, so the target-status color band lives on a plain <div> wrapper
                // (same convention as ContainerCard.js / ScrubTable.js).
                return (
                    <div key={widget.widgetId} style={this.getWidgetCardStyle(widget)}>
                        <Box type="outline" spacingInset="large">
                            <Column spacing="small">
                                <Row spacing="xsmall" alignmentVertical="center">
                                    <Text type="h200">
                                        <b><FormattedMessage id={widget.titleId} defaultMessage={widget.displayName || widget.defaultTitle}/></b>
                                    </Text>
                                    <Tooltip position="end" title={<FormattedMessage id={widget.tooltipId} defaultMessage={widget.tooltip || widget.defaultTooltip}/> }>
                                        <Icon tokens={infoKnockoutTokens}/>
                                    </Tooltip>
                                </Row>
                                <Text type="d100">
                                    {this.getWidgetValueNode(widget)}
                                </Text>
                                <Text type="b200" color={"secondary"}>
                                    {isPercentage ? (
                                        <FormattedMessage id={widget.targetLabelId} defaultMessage={widget.targetLabel || widget.defaultTargetLabel}/>
                                    ) : (
                                        <FormattedMessage id={widget.unitId} defaultMessage={widget.defaultUnit}/>
                                    )}
                                </Text>
                            </Column>
                        </Box>
                    </div>
                );
            })}
        </Row>
        )) : null}

        <RefreshTimer deps={[this.props.data]}/>
        <Row widths={["grid-8"]}>
            <div>
            <Table spacingInset="medium"  spacing="small">
                <TableRow alignmentHorizontal = "left">
                    <TableCell>
                       <Text type="h100">
                           <FormattedMessage id="rts.status" defaultMessage="Status"/>
                       </Text>
                    </TableCell>
                    <TableCell alignmentHorizontal = "right"><Text type="h100">
                        <FormattedMessage id="rts.today" defaultMessage="Today"/>
                    </Text></TableCell>
                </TableRow>
                { this.props.isLoading ? <TableRow><TableCell columnSpan = {7} alignmentHorizontal = "center"><Loader/></TableCell></TableRow>: 
                     this.props.data && this.props.data.length > 0 && processedRtsRowMapping.map(section => (

                    <TableRow key={section.Section} data-test={sectionTestId(section.Section)} open={this.isSectionExpanded(section.Section)} onClick={() => this.toggleRow(section.Section)}>
                        <TableCell  alignmentHorizontal = "left"><FormattedMessage id ={rtsMessageId(section.Section)} defaultMessage={section.Section}/>{this.renderBucketInfo(section.Section)}</TableCell>
                        { Columns.map( col =>
                        <TableCell key={`${section.Section}-${col}`} alignmentHorizontal = "right">
                            {this.getSectionMetricFromSubsectionData(section, col) !== 0 ? 
                            <Link href = {this.constructState(section.Subsections.length > 0 ? section.Subsections.map( subsection => {return subsection.Section ? subsection.Subsections.filter(sub=> sub !== subsection.Section) : subsection}) : section.Section, timeColumn)} type="secondary">
                                {this.getSectionMetricFromSubsectionData(section, col)}
                            </Link> : this.getSectionMetricFromSubsectionData(section, col)}
                        </TableCell> )}

                        { section.Subsections.map(subsection => subsection.Section ? subsection.Subsections.map(sub=> 

                                   sub === subsection.Section ?
                                  <TableRow key={subsection.Section} data-test={subsectionTestId(subsection.Section)} open={this.isSectionExpanded(subsection.Section)} onClick={() => this.toggleRow(subsection.Section)}>
                                      <TableCell alignmentHorizontal = "left">
                                         <Row spacingInset="none none none medium">
                                                <Icon tokens={this.isSectionExpanded(subsection.Section) ? chevronDownSmallTokens : chevronRightSmallTokens}/>
                                                <FormattedMessage id ={rtsMessageId(subsection.Section)} defaultMessage={subsection.Section}/>{this.renderBucketInfo(subsection.Section)}</Row>
                                    </TableCell>
                                { Columns.map( col => <TableCell key={`${subsection.Section}-${col}`} alignmentHorizontal = "right">
                                {this.getSectionMetricFromSubsectionData(subsection, col) !== 0 ? 
                                    <Link href = {this.constructState(subsection.Subsections.length > 0 ? subsection.Subsections.filter( s => s !== subsection.Section) : 
                                        subsection.Section, timeColumn)} type="secondary">
                                         {this.getSectionMetricFromSubsectionData(subsection, col)}
                                     </Link> : this.getSectionMetricFromSubsectionData(subsection, col)}
                                    </TableCell> )} </TableRow> :
                                 this.isSectionExpanded(subsection.Section) ? <TableRow key={sub} data-test={rowTestId(sub)}>
                                 <TableCell  alignmentHorizontal = "left"><Row spacingInset="none none none xlarge"><FormattedMessage id ={rtsMessageId(this.backendStateToMetricMapping(sub))} defaultMessage={this.backendStateToMetricMapping(sub)}/>{this.renderBucketInfo(sub)}</Row></TableCell>
                                { Columns.map( col =>

                                <TableCell key={`${sub}-${col}`} alignmentHorizontal = "right">
                                    {this.getMetricFromPackageToColumnMap(sub.split(" (", 1)[0], col, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "").toString() !== "0"  ? 
                                 <Link href = {this.constructState(sub, timeColumn)} type="secondary">
                                     {this.getMetricFromPackageToColumnMap(sub.split(" (", 1)[0], col, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                </Link> : this.getMetricFromPackageToColumnMap(sub.split(" (", 1)[0], col, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                </TableCell> )} </TableRow>
                        
                            : null ):

                            <TableRow key={subsection} data-test={rowTestId(subsection)}>
                                <TableCell alignmentHorizontal = "left" ><Row spacingInset="none none none medium"><FormattedMessage id ={rtsMessageId(handlePackageStateToGenericTextMapping("RTS", section.Section, subsection, "DEFAULT_VIEW", this.props.isRtsAgeingGenericLabelsEnabled))} defaultMessage={subsection}/>{this.renderBucketInfo(subsection)}</Row></TableCell>
                                { Columns.map(col =>
                            
                            <TableCell key={`${subsection}-${col}`} alignmentHorizontal = "right">
                                {this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "").toString() !== "0" ?
                                <Link href = {this.constructState(subsection, timeColumn)} type="secondary">
                                    {this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                </Link> : this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")}
                            </TableCell>)}
                        </TableRow>)}
                        </TableRow>
                ))}
            </Table>
        </div>
    </Row>
            </React.Fragment>
        )}
    </Column>
    );
    }}
    </FeatureConfigContext.Consumer>
)
 }
}
                    



// WEBPACK FOOTER //
// ./src/components/rts/RTSDataUI.js